const IconEye = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.5" clipPath="url(#clip0_2765_127170)">
      <path
        d="M69.6013 39.3271C63.3875 27.203 51.0858 19 37 19C22.9142 19 10.6091 27.2087 4.39869 39.3282C4.13657 39.8467 4 40.4196 4 41.0006C4 41.5816 4.13657 42.1544 4.39869 42.6729C10.6126 54.797 22.9142 63.0001 37 63.0001C51.0858 63.0001 63.3909 54.7913 69.6013 42.6718C69.8634 42.1533 70 41.5804 70 40.9994C70 40.4184 69.8634 39.8456 69.6013 39.3271ZM37 57.5C33.7366 57.5 30.5465 56.5323 27.8331 54.7193C25.1197 52.9062 23.0048 50.3293 21.756 47.3143C20.5071 44.2993 20.1804 40.9817 20.817 37.781C21.4537 34.5803 23.0251 31.6403 25.3327 29.3327C27.6403 27.0252 30.5803 25.4537 33.781 24.817C36.9817 24.1804 40.2993 24.5071 43.3143 25.756C46.3293 27.0048 48.9062 29.1197 50.7193 31.8331C52.5323 34.5465 53.5 37.7366 53.5 41C53.5011 43.1671 53.075 45.3132 52.2462 47.3156C51.4174 49.3179 50.202 51.1373 48.6696 52.6696C47.1373 54.202 45.3179 55.4174 43.3155 56.2462C41.3132 57.075 39.1671 57.5011 37 57.5ZM37 30C36.0182 30.0137 35.0427 30.1598 34.0999 30.4343C34.877 31.4903 35.2499 32.79 35.151 34.0974C35.0521 35.4049 34.4879 36.6336 33.5608 37.5608C32.6336 38.4879 31.4049 39.0521 30.0974 39.151C28.79 39.25 27.4903 38.877 26.4343 38.0999C25.8329 40.3155 25.9414 42.6639 26.7446 44.8145C27.5478 46.9651 29.0053 48.8098 30.9117 50.0887C32.8182 51.3677 35.0778 52.0166 37.3724 51.9441C39.667 51.8716 41.881 51.0814 43.703 49.6847C45.525 48.2879 46.863 46.355 47.5289 44.1579C48.1947 41.9609 48.1549 39.6103 47.4148 37.4371C46.6748 35.2639 45.2719 33.3775 43.4037 32.0434C41.5354 30.7092 39.2957 29.9946 37 30Z"
        fill="#ACBDD3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.2993 15.5816C5.97537 14.7081 7.23155 14.548 8.10505 15.2241L67.3317 61.0646C68.2052 61.7406 68.3652 62.9968 67.6892 63.8703C67.0131 64.7438 65.7569 64.9039 64.8834 64.2278L5.65677 18.3873C4.78327 17.7113 4.62323 16.4551 5.2993 15.5816Z"
        fill="#ACBDD3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.22508 18.6423C3.90115 17.7688 5.15733 17.6088 6.03083 18.2848L65.2575 64.1253C66.131 64.8014 66.291 66.0575 65.615 66.931C64.9389 67.8045 63.6827 67.9646 62.8092 67.2885L3.58255 21.4481C2.70905 20.772 2.54901 19.5158 3.22508 18.6423Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2765_127170">
        <rect
          width="66.9143"
          height="54.5127"
          fill="white"
          transform="translate(3.21094 13.9674)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default IconEye
